<template>
  <div>
      	<!-- Footer -->
	<footer class="bg3 p-t-75 p-b-32">
		<div class="container">
			<div class="row">
			

				<div class="col-sm-4 col-lg-4 p-b-20">
					<h4 class="stext-301 cl0 p-b-30 f-font">
						Store
					</h4>

					<ul>
						<li class="p-b-10">
							<router-link  :to="{name: 'storehome'}" class="stext-107 cl7 hov-cl1 trans-04">
								Home
							</router-link>
						</li>

						<li class="p-b-10">
							<router-link v-if="plan != 'Starter'" :to="{name: 'storecategories'}" class="stext-107 cl7 hov-cl1 trans-04">
								Categories 
							</router-link>
						</li>

						<li class="p-b-10">
							<router-link  :to="{name: 'storeoffers'}" class="stext-107 cl7 hov-cl1 trans-04">
								Offers 
							</router-link>
						</li>

						<li class="p-b-10">
							<router-link  :to="{name: 'storeabout'}" class="stext-107 cl7 hov-cl1 trans-04">
								About
							</router-link>
						</li>

						<li class="p-b-10">
							<router-link  :to="{name: 'storecontact'}" class="stext-107 cl7 hov-cl1 trans-04">
								Contact
							</router-link>
						</li>
					</ul>
				</div>

					<div class=" col-sm-4 col-lg-4 p-b-20">
					<h4 class="stext-301 cl0 p-b-20 f-font">
						GET IN TOUCH
					</h4>

					<p class="stext-107 cl7 mb-3 size-201">
						Any questions? Let us know in store at {{address}} or call us on +94 {{tel1}}
					</p>
					<ul class="social-media-icons mb-2   d-inline">
              <li v-if="fbpage != ''"><a :href="fbpage" class="px-0 ml-0 mr-2 "><i class="fa fa-facebook-official  f-sm-link" style="font-size:34px; color:#3b5998; background-color:#fff; width: 30px; height: 30px; border-radius: 4px; text-align: center; vertical-align: middle;"></i></a></li>
              <li v-if="insta != ''"><a :href="insta" class="px-0 mx-2"><i class="fa fa-instagram  f-sm-link " style="font-size:30px; color:#fff; background: #d6249f;
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%); width: 32px; height: 32px; border-radius: 4px; text-align: center; vertical-align: middle;"></i></a></li>
              <li v-if="youtube != ''"><a :href="youtube" class="px-0 mx-2"><i class="fa fa-youtube-square  f-sm-link" style="font-size:35px; color:#FF0000;background-color:#fff; width: 30px; height: 30px; border-radius: 6px; text-align: center; vertical-align: middle;"></i></a></li>
            </ul>
				</div>

				<div class=" col-sm-4 col-lg-4 p-b-30">
					<h4 class="stext-301 cl0 p-b-20 f-font">
						Get the Mobile App
					</h4>

					 <div class="block-2 app-promotion">
					<a >
						<!-- Icon -->
					<img src="../../../static/img/icons/footer-android-chrome-76x76.png" alt="mobile-icon" class="mt-3 mb-2">
					</a>
					<p class="m-f-text text-white">Tap the Add to Home Screen Tab in Chrome Browser on Android or Safari Browser on IOS to Get the  Splendid <span style="color:#FD6A02;font-size:20px;">Mobile App</span> Directly</p>
					</div>

					<!-- <div class="p-t-16">
						<a href="#" class="fs-18 cl7 hov-cl1 trans-04 m-r-16">
							<i class="fa fa-facebook"></i>
						</a>

					</div> -->
				</div>

				<!-- <div class="col-sm-6 col-lg-3 p-b-50">
					<h4 class="stext-301 cl0 p-b-30">
						Newsletter
					</h4>

					<form>
						<div class="wrap-input1 w-full p-b-4">
							<input class="input1 bg-none plh1 stext-107 cl7" type="text" name="email" placeholder="email@example.com">
							<div class="focus-input1 trans-04"></div>
						</div>

						<div class="p-t-18">
							<button class="flex-c-m stext-101 cl0 size-103 bg1 bor1 hov-btn2 p-lr-15 trans-04">
								Subscribe
							</button>
						</div>
					</form>
				</div> -->
			</div>

			<div class="p-t-1">
				<div class="flex-c-m flex-w p-b-18">
					<h4 class="text-white">See Us On <br></h4>
					<a class="m-all-1 " href="https://eshops.lk/" target="blank">
						<img class="d-block" src="../../../static/img/eshops-logo.png" alt="eshops-logo">
					</a>

				</div>

				<p class="stext-107 cl6 txt-center">
					&copy; 2019 {{dname}} | All Rights Reserved
				</p>
			</div>
		</div>
	</footer>


	<!-- Back to top -->
	<div class="btn-back-to-top" id="myBtn">
		<span class="symbol-btn-back-to-top">
			<i class="fa fa-chevron-up"></i>
		</span>
	</div>

  </div>
</template>

<script>
 import db from "../../config/FirebaseInit"
// import firebase from "firebase"
 export default {
 data () {
	 return {
	shops:[],
	address:'',
	email:'',
	tel1:'',
	tel2:'',
	plan:'',
	dname:'',
	fbpage:'',
	insta:'',
	youtube:''
	
  }
 },
   created(){
		  //console.log("navigator.onLine", navigator.onLine)
	 if(this.$store.state.shops[0] != undefined){
		 this.address = this.$store.state.shops[0].details.address
		 this.email = this.$store.state.shops[0].details.email
		 this.tel1 = this.$store.state.shops[0].details.tel1
		 this.tel2 = this.$store.state.shops[0].details.tel2
		 this.plan = this.$store.state.shops[0].plan
		 this.dname = this.$store.state.shops[0].details.dname
		this.fbpage = this.$store.state.shops[0].details.fbpage
		this.insta = this.$store.state.shops[0].details.insta
		this.youtube = this.$store.state.shops[0].details.youtube
		 console.log('footer .$store.state.shops[0] is', this.$store.state.shops[0])
	 }else{
		 db.collection('shops').get()
      	.then(querySnapshot => {
      	querySnapshot.forEach(doc => {
		const data = {
		    'shoptype' : doc.data().shoptype,
			'details': doc.data().details,
			'plan' : doc.data().plan   
        }
        this.shops.push(data)
			this.address = this.shops[0].details.address
			this.email = this.shops[0].details.email
			this.tel1 = this.shops[0].details.tel1
			this.tel2 = this.shops[0].details.tel2
			this.plan = this.shops[0].plan
			this.dname = this.shops[0].details.dname
			this.fbpage = this.shops[0].details.fbpage
			this.insta = this.shops[0].details.insta
			this.youtube = this.shops[0].details.youtube
		 
			console.log("footer details are", this.shops[0].details)
		  //console.log("url is", this.url)
      })
	})
	 }
		
  }
}
 </script>
 <style scoped>
 .f-font{
	font-family: 'Poppins'
}
 .shopin{
	 text-transform: none;
 }
 .social-media-icons {
  text-align: center !important;
}

.social-media-icons li {
  display: inline-block;
}

.social-media-icons li a {
  color: #848484;
  padding: 0 15px;
}

.social-media-icons li a:hover {
  color: #fff !important;
  text-decoration: none;
}
@media (max-width: 575px){
  .m-f-text{
    font-size: 12px;
  }
}
 </style>
 


// WEBPACK FOOTER //
// src/components/store/StoreFooter.vue